import React, { useCallback, useRef } from 'react';
import ActionTypes from '../base/ActionTypes';

import { IAction } from '../interfaces/IAction';
import { useDispatch } from '../context/Store/StoreHooks';


// Import required components
import { createObservable } from '../utilities/UtilityLibrary';
import { IServerCommand } from '../utilities/NetworkLibrary';
import { DesignDialog } from './DesignDialog';
import { DesignDialogActionsProvider } from './DesignDialogActionsProvider';


interface DialogControlProps {
    sendActionToParent: any;
    actionFromParent?: IAction;
    runSimpleAjaxCommandAsync: (requestObj: IServerCommand) => Promise<any>;
}

export const DesignDialogContainer: React.FC<DialogControlProps> = ({
    sendActionToParent,
    actionFromParent,
    runSimpleAjaxCommandAsync,
}: DialogControlProps) => {

    const dispatch = useDispatch();

    const dialogStateToPropsObservable = useRef<any>(createObservable({}));

    const changeBlockDialogStatus = useCallback((block: boolean) => {
        dispatch({ type: ActionTypes.STORE_UpdateIsDialogBlockedAction, payload: block });
    }, [dispatch]);

    const sendActionToChildren = useCallback((action: IAction) => {
        dialogStateToPropsObservable.current(action);
    }, []);




    return <DesignDialogActionsProvider
        runSimpleAjaxCommandAsync={runSimpleAjaxCommandAsync}
        sendActionToParent={sendActionToParent}
        changeBlockDialogStatus={changeBlockDialogStatus}
        sendActionToChildren={sendActionToChildren}
        dialogStateToPropsObservable={dialogStateToPropsObservable}>
        <DesignDialog actionFromParent={actionFromParent} />
    </DesignDialogActionsProvider>


};
